import { Reveal, Eyebrow } from "@/components/site/Reveal";

const POINTS = [
  ["01", "Blood flow", "The maker's angle: supporting healthy blood flow around the prostate, citing a 2023 study from Fukushima Medical University, Japan."],
  ["02", "Nitric oxide", "A molecule that helps blood vessels relax. ProstaVive aims to maintain healthy levels so nutrient-rich blood keeps moving."],
  ["03", "The knock-on", "A healthy prostate is linked to better urine flow, sleep and confidence. Check symptoms with your doctor first."],
];

export const ProstaWhy = () => (
  <section id="why" className="bg-[#F2EDE4] py-24 sm:py-32" data-testid="prosta-why-section">
    <div className="mx-auto grid max-w-7xl grid-cols-1 gap-12 px-5 sm:px-8 lg:grid-cols-12">
      <Reveal className="lg:col-span-5">
        <Eyebrow className="!text-[#0A6FA0]">How it's meant to work</Eyebrow>
        <h2 className="mt-5 font-display text-4xl font-bold leading-[1.02] tracking-tight text-[#071E33] sm:text-5xl">
          It starts with <span className="font-serif italic font-normal text-[#0A6FA0]">circulation.</span>
        </h2>
      </Reveal>
      <div className="grid grid-cols-1 gap-4 md:grid-cols-3 lg:col-span-7">
        {POINTS.map(([n, t, d], i) => (
          <Reveal key={n} delay={i * 0.1} className="h-full">
            <div className="flex h-full flex-col justify-between rounded-[1.75rem] bg-[#071E33] p-6 transition-transform duration-500 hover:-translate-y-1" data-testid={`prosta-why-${n}`}>
              <span className="font-mono text-sm text-[#00AEEF]">{n}</span>
              <div className="mt-10">
                <h3 className="font-display text-xl font-semibold text-[#F2EDE4]">{t}</h3>
                <p className="mt-3 text-sm leading-relaxed text-[#F2EDE4]/75">{d}</p>
              </div>
            </div>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
